import useProductOrderStatus from "./react-query/useProductOrderStatus";
import { useAuth } from "../context/AuthContext";

export const useAmazonInsuranceCheck = () => {
  const { currentUser } = useAuth();
  const { productData, isProductLoading, isUserLoading } =
    useProductOrderStatus(currentUser?.uid ?? "");

  return {
    isLoadingProductData: isUserLoading || isProductLoading,
    productData: productData,
  };
};
